module.exports = __webpack_public_path__ + "static/media/mri-mai-logo.3a592fc5.png";